import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import BigNumber from 'bignumber.js';
import { take } from 'rxjs/operators';
import { NETWORKS, PAYMENT_MODES } from 'src/app/angular-wallet-base/constants';
import { SmallToCryptoPipe } from 'src/app/angular-wallet-base/pipes/smalltocrypto/smalltocrypto.pipe';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { NetworkService } from 'src/app/angular-wallet-base/services/network.service';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { getKeychain } from 'src/app/angular-wallet-base/store/wallet';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { filterByTokenSymbol, getCurrentNetworkIcon, getCurrentNetworkLabel, getTokenInfoArray, groupByTokenSymbol } from 'src/app/angular-wallet-base/utils';

@Component({
  selector: 'app-select-network-modal',
  templateUrl: './select-network-modal.html',
  styleUrls: ['./select-network-modal.scss'],
})
export class SelectNetworkModal extends SubscriptionListenerComponent implements OnInit {
  public isDesktopMode: boolean;
  public itemsTemp;
  public items = [];
  
  public progressBar: boolean;

  constructor(
    private modalController: ModalController,
    public appMode: AppModeService,
    protected store: Store<AppState>,
    private networkManager: NetworkService,
    private translate: TranslateService,

  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit(): Promise<void> {
    this.itemsTemp = this.items;
    this.progressBar = true;
    this.subscriptions.add(
      await this.store.select(getKeychain).pipe(take(1)).toPromise().then(async (keychain) => {
        if (!keychain) {
          // Prevent error on wallet reset.
          return;
        }
        const tokens = await Promise.all(
          getTokenInfoArray(keychain)
            // TODO: Removed tokens other than AVAX
            .filter(token => (['SYSNEVM'].includes(token.baseChainSymbol) && ['SYSNEVM'].includes(token.symbol)))
            .sort((a, b) => a.symbol.charCodeAt(0) - b.symbol.charCodeAt(0))
            .map(async (token) => {
              const tokenCopy: any = { ...token };
              tokenCopy.networkLabel = await getCurrentNetworkLabel(
                {
                    tokenInfo: tokenCopy,
                    networkManager: this.networkManager,
                    translateService: this.translate
                }
              );
              tokenCopy.network = "";
              tokenCopy.childElements = [];
              tokenCopy.iconChain = await getCurrentNetworkIcon(tokenCopy.symbol, tokenCopy.baseChainSymbol);
              tokenCopy.isExpanded = false;
              return tokenCopy;
            })
        );

        // We have some new requirements 
        this.items = await filterByTokenSymbol(tokens, 'symbol');
        Logger.info("filteredTokensBySymbol ",this.items)        
        this.progressBar = false;
        this.itemsTemp = this.items;
        Logger.info("networkcoins ",this.itemsTemp)
      })
    );
  }

  async selectNetwork(item) {
    await this.modalController.dismiss({ networkInfo: item }, '', 'selectNetworkModal');
  }

  async closeModal() {
    await this.modalController.dismiss({}, '', 'selectNetworkModal');
  }

  SearchToken(ev) {
    this.itemsTemp = this.items.filter((item) => item.network.toLowerCase().includes(ev.target.value.toLowerCase()));
  }


}
